import OrderComp from '../components/orderComp';

const Order = () => {
    return <OrderComp />;
};

export default Order;
